import { render, staticRenderFns } from "./AccountPackageSelector.vue?vue&type=template&id=01dc472a&scoped=true"
import script from "./AccountPackageSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountPackageSelector.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccountPackageSelector.vue?vue&type=style&index=0&id=01dc472a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dc472a",
  null
  
)

export default component.exports